function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50 25C50 38.8073 38.8073 50 25 50C11.1927 50 0 38.8073 0 25C0 11.1927 11.1927 0 25 0C38.8073 0 50 11.1927 50 25Z",
  fill: "url(#paint0_linear-referral)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.7329 24.8302C24.8221 24.8334 24.9112 24.8356 25.0006 24.8356C25.0844 24.8356 25.1678 24.8337 25.2509 24.8309C27.1081 24.8718 28.9348 25.3634 30.5484 26.2614C31.1364 26.5887 31.878 26.3772 32.2051 25.7894C32.5324 25.2017 32.3208 24.4601 31.7331 24.133C31.0587 23.7575 30.3536 23.4419 29.6272 23.1853C31.2735 21.841 32.3262 19.7964 32.3262 17.5103C32.3262 13.4712 29.0401 10.1851 25.001 10.1851C20.9615 10.1851 17.6754 13.4712 17.6754 17.5103C17.6754 19.7973 18.7291 21.8426 20.3763 23.1868C18.8664 23.721 17.4492 24.5149 16.1998 25.5426C13.7631 27.547 12.0686 30.3427 11.4292 33.4151C11.2211 34.4149 11.4704 35.4423 12.1137 36.233C12.7538 37.0203 13.7028 37.4717 14.7178 37.4717H22.9474C23.6202 37.4717 24.1655 36.9264 24.1655 36.2536C24.1655 35.5809 23.6202 35.0356 22.9474 35.0356H14.7178C14.3366 35.0356 14.1066 34.8228 14.0035 34.6959C13.8985 34.5668 13.7345 34.2937 13.8138 33.9115C14.8917 28.7349 19.4593 24.9542 24.7329 24.8302ZM20.1114 17.5103C20.1114 14.8142 22.3048 12.6208 25.0006 12.6208C27.6968 12.6208 29.8902 14.8142 29.8902 17.5103C29.8902 20.1354 27.8103 22.2832 25.2119 22.3942C25.1415 22.3932 25.0711 22.3907 25.0006 22.3907C24.9204 22.3907 24.8405 22.3919 24.7602 22.3932C22.1757 22.2676 20.1114 20.1256 20.1114 17.5103Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.8167 27.9493L35.8612 26.0157C35.3829 25.5424 34.6118 25.5469 34.1388 26.0252C33.6659 26.5035 33.6703 27.2746 34.1484 27.7479L35.0768 28.6658H29.6077C27.1799 28.6658 25.2051 30.641 25.2051 33.0688C25.2051 35.4963 27.1685 37.4714 29.582 37.4714C30.2548 37.4714 30.8001 36.9262 30.8001 36.2534C30.8001 35.5807 30.2548 35.0354 29.582 35.0354C28.5118 35.0354 27.6411 34.153 27.6411 33.0688C27.6411 31.9843 28.5232 31.1019 29.6077 31.1019H35.1751L34.1461 32.1255C33.6691 32.5997 33.6669 33.3708 34.1414 33.8478C34.3793 34.0873 34.692 34.2069 35.0048 34.2069C35.3156 34.2069 35.6262 34.0889 35.8637 33.8526L37.8224 31.905C38.3537 31.3766 38.6459 30.674 38.6449 29.9264C38.6439 29.1784 38.3499 28.4765 37.8167 27.9493Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear-referral",
  x1: 28,
  y1: 50,
  x2: 28,
  y2: 5.32076e-8,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#5CBBFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#79EFFF"
})));

var SvgReferral = function SvgReferral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReferral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/referral.a082fc57.svg";
export { ForwardRef as ReactComponent };